import { MenuItem, toast } from "../../vendor/ds-react";
import {
  ContextMenuItem,
  ContextMenuSeparator,
} from "../../vendor/src/features/remotion-editor/editor/context-menu";
import { openFrameVideoPicker } from "../host/frame-video-picker";
export function FrameVideoContextMenu({ clipId, sourceType = "video" }: { clipId: string; sourceType?: "image" | "video" }) {
  return (
    <>
      <ContextMenuSeparator />
      <ContextMenuItem
        title={sourceType === "image" ? "이 이미지 원본으로 영상을 만들어 컷 뒤에 추가합니다." : "재생선을 이 영상 클립 안에 둔 뒤 선택하세요."}
        onPointerDown={(event) => event.stopPropagation()}
        onSelect={() =>
          requestAnimationFrame(() => {
            try {
              openFrameVideoPicker(clipId);
            } catch {
              toast({
                type: "error",
                description: "편집기 준비 후 다시 시도해 주세요.",
              });
            }
          })
        }
      >
        <MenuItem
          size="md"
          showLeadingIcon={false}
          text={sourceType === "image" ? "이 이미지로 영상 만들기" : "이 프레임으로 영상 만들기"}
          subText={sourceType === "image" ? "컷 뒤에 추가" : "재생선 기준"}
          className="w-full"
        />
      </ContextMenuItem>
    </>
  );
}
